module.exports = __webpack_public_path__ + "static/media/app icon (8).68e60b06.png";